import swal from 'sweetalert';

/* eslint-disable import/prefer-default-export */
export const isURL = (url) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?'// query string
    + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return pattern.test(url);
};

export const errorMessage = (error) => {
  let errorText = '';
  if (typeof error === 'object' && error.errors) {
    Object.keys(error.errors).forEach((key) => {
      errorText += `${error.errors[key].toString()}\n`;
    });
  } else if (Array.isArray(error)) {
    errorText = error.join('\n');
  } else {
    errorText = error.toString();
  }

  return swal({
    title: 'Something was wrong!',
    text: errorText,
    icon: 'error',
  });
};
